export default theme => ({
  status: {
    color: theme.palette.secondary.dark,
    border: `1px solid ${theme.palette.secondary.dark}`,
    marginTop: theme.sizes[2],
  },
});
